import { baseUrl } from "../BaseUrl";
import axios from "axios";

const NBRE_ELEMENT = 20;

// TODO: adapter les routes ci-dessous une fois les endpoints API communiqués.

export const rechercherlistepackages = async (
  page,
  param = "",
  restaurantId = "",
  entrepriseId = "",
  siteId = ""
) => {
  return await axios.get(
    baseUrl(
      `rechercherlistecombinaisons?page=${page}&size=${NBRE_ELEMENT}&param=${param}&restaurantId=${restaurantId}&entrepriseId=${entrepriseId}&siteId=${siteId}`
    )
  );
};

export const rechercherelementsdecombinaison = async (combinaisonId) => {
  return await axios.get(
    baseUrl(
      `rechercherlisteelementsdecombinaisonparcombinaison/${combinaisonId}`
    )
  );
};

export const enregistrerpackage = async (values) => {
  return await axios.post(baseUrl(`enregistrerunecombinaison`), values);
};

export const supprimerpackage = async (id) => {
  return await axios.delete(baseUrl(`supprimercombinaison/${id}`));
};

export const supprimerelementdecombinaison = async (id) => {
  return await axios.delete(baseUrl(`supprimerelementdecombinaison/${id}`));
};

export const activerpackageobligatoire = async (restaurantId = "") => {
  return await axios.post(
    baseUrl(`modifieretatobligationcombinaison?restaurantId=${restaurantId}`)
  );
};
